/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["agm-map[_ngcontent-%COMP%]    {width:100%}@media only screen and (min-width:960px){agm-map[_ngcontent-%COMP%]    {width:60%!important;margin-left:0!important;margin-right:auto!important}}@media only screen and (min-width:1280px){agm-map[_ngcontent-%COMP%]    {width:70%!important}}agm-map[_ngcontent-%COMP%]     .agm-map-container-inner{width:100%}@media screen and (max-width:959px){agm-map[_ngcontent-%COMP%]     .agm-map-container-inner{height:360px}}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/localisation/gmap.component.scss.shim.ngstyle.js.pre-build-optimizer.js